export const RESET_STATE = 'ROOT_RESET_STATE';

const resetState = () => ({
    type: RESET_STATE
});

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
    resetState
}